import { Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import Contact from "./components/Contact";
import "./App.css";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HowItWorks from "./components/HowItWorks";
import Faqs from "./components/Faqs";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsOfUsePage";

function App() {
  return (
    <div
      className="App"
      style={{ backgroundColor: "#f7f8fa", paddingBottom: 64 }}
    >
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="how-it-works" element={<HowItWorks />} />
        <Route path="contact" element={<Contact />} />
        <Route path="faqs" element={<Faqs />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
